var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"disabled":_vm.defaultForBlock === true,"loading":_vm.loading},on:{"change":_vm.setPackageDefault},model:{value:(_vm.defaultForBlock),callback:function ($$v) {_vm.defaultForBlock=$$v},expression:"defaultForBlock"}})}
var staticRenderFns = []

export { render, staticRenderFns }